import pallete from './pallete';
import typography from './typography';

export default {
  pallete,
  typography,
};
